export default "__VITE_ASSET__C2ruSO_y__"